import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import SpaceViewer from "./SpaceViewer";
import LibraryBookFinder from "./LibraryBookFinder";

const RootHandler = () => {
  const [shouldRedirect, setShouldRedirect] = React.useState(false);

  useEffect(() => {
    // if there are query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const hasQueryParams = urlParams.toString().length > 0;

    if (!hasQueryParams) {
      setShouldRedirect(true);
      window.location.href = "https://www.library.ln.edu.hk";
    }
  }, []);

  // if redirecting show loading message
  if (shouldRedirect) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'Arial, sans-serif',
        color: '#666'
      }}>
        <p>Redirecting to library website...</p>
      </div>
    );
  }

  // If there are query parameters, show the LibraryBookFinder
  return <LibraryBookFinder />;
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Handle root path - redirect if no query params, otherwise show LibraryBookFinder */}
        <Route
          path="/"
          element={<RootHandler />}
        />

        <Route
          path="/facility"
          element={<SpaceViewer />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
